module.exports = __webpack_public_path__ + "img/garage-door(1).99bea754.jpg";